var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 18.9799H7.30002C6.88002 18.9799 6.41002 18.6499 6.27002 18.2499L2.13002 6.66986C1.54002 5.00986 2.23002 4.49986 3.65002 5.51986L7.55002 8.30986C8.20002 8.75986 8.94002 8.52986 9.22002 7.79986L10.98 3.10986C11.54 1.60986 12.47 1.60986 13.03 3.10986L14.79 7.79986C15.07 8.52986 15.81 8.75986 16.45 8.30986L20.11 5.69986C21.67 4.57986 22.42 5.14986 21.78 6.95986L17.74 18.2699C17.59 18.6499 17.12 18.9799 16.7 18.9799Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 22H17.5",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14H14.5",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.e1a168ffd8ea2f55ce2052fc813fbe33.svg";
export { ForwardRef as ReactComponent };